import { GenericObject, InquiryOfferState, copyFields, fixDates } from '@synergy/models';
import { Media } from '@synergy/models';

import { Account } from './account';
import { Contact } from './contact';
import { OfferCompleteStatus } from './enums/offer-complete-status';
import { OfferItem } from './offer-item';
import { OfferStatus } from './enums/offer-status';
import { User } from './user';

export class Offer {
    public id!: number;
    public accountPurchaseId!: number;
    public status!: OfferStatus;
    public completeStatus!: OfferCompleteStatus;
    public deliveryPrice!: number;
    public surcharge!: number;
    public discount!: number;
    public supplierAccount!: Account;
    public supplierContact?: Contact;
    public noteFromSupplier?: string;
    public media!: Media[];
    public offerItems!: OfferItem[];
    public createdBy!: User;
    public updateBy!: User;
    public createdAt!: Date;
    public updatedAt!: Date;
    public termsOfPaymentContent?: string;
    public termsOfDeliveryContent?: string;
    public supplierBonus?: string;
    public isDeclinedBySupplier?: boolean;
    public supplierDeclinedReason?: string;
    public supplierOfferNumber?: string;
    public inquiryOfferState!: InquiryOfferState;

    public static fromPlainObject(object: GenericObject): Offer {
        const offer = new Offer();

        copyFields(object, offer);

        if (object['supplierAccount']) {
            offer.supplierAccount = Account.fromPlainObject(object['supplierAccount']);
        }

        if (object['supplierContact']) {
            offer.supplierContact = Contact.fromPlainObject(object['supplierContact']);
        }

        if (object['offerItems']) {
            offer.offerItems = object['offerItems'].map(OfferItem.fromPlainObject);
        }

        if (object['media']) {
            offer.media = object['media'].map(Media.fromPlainObject);
        }

        if (object['createdBy']) {
            offer.createdBy = User.fromPlainObject(object['createdBy']);
        }

        if (object['updateBy']) {
            offer.updateBy = User.fromPlainObject(object['updateBy']);
        }

        fixDates(offer, ['createdAt', 'updatedAt']);

        return offer;
    }

    public getTotal(): number {
        const totalSum =
            (this.offerItems.reduce(
                (total, offerItem) =>
                    offerItem.isOffered || offerItem.isAlternative
                        ? total + (offerItem.price || 0) * offerItem.quantity
                        : total,
                0
            ) *
                (100 - (this.discount || 0))) /
            100;
        return totalSum;
    }

    public getTotalWithCosts(): number {
        return this.getTotal() + (this.deliveryPrice || 0) + (this.surcharge || 0);
    }
}
